import { HelpCircleIcon, InfoCircleIcon } from '@langchain/untitled-ui-icons';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

export function InfoTooltip({
  title,
  description,
  size = 'md',
  icon = 'question',
}: {
  title?: string;
  description?: string;
  size?: 'sm' | 'md';
  icon?: 'question' | 'info';
}) {
  const Icon = (() => {
    switch (icon) {
      case 'info':
        return InfoCircleIcon;
      case 'question':
      default:
        return HelpCircleIcon;
    }
  })();

  return (
    <Tooltip title={title} description={description}>
      <div>
        <Icon
          className={cn(
            'h-4 w-4 text-quaternary',
            size === 'sm' && 'h-3.5 w-3.5'
          )}
        />
      </div>
    </Tooltip>
  );
}
